import { LitElement, html } from "lit";
import { docPopup, faSvg, titles } from "../styles.js";
import { fa } from "../../utils/widgets.js";
import { faExternalLinkAlt, faMedal } from "@fortawesome/free-solid-svg-icons";

/**
 * Quality Score Doc displays a synthetic summary of how Quality Score is computed.
 * @class Panoramax.components.menus.QualityScoreDoc
 * @element pnx-quality-score-doc
 * @extends [lit.LitElement](https://lit.dev/docs/api/LitElement/)
 * @example
 * ```html
 * <pnx-quality-score-doc ._t=${viewer._t} />
 * ```
 */
export default class QualityScoreDoc extends LitElement {
	static styles = [ titles, faSvg, docPopup ];

	render() {
		return html`
			<h4>${fa(faMedal)} ${this._t?.pnx.filter_qualityscore}</h4>
			<p>${this._t?.pnx.qualityscore_doc_1}</p>
			<p>${this._t?.pnx.qualityscore_doc_2}</p>
			<pnx-quality-score grade=""></pnx-quality-score>
			<p>${this._t?.pnx.qualityscore_doc_3}</p>
			<p>${this._t?.pnx.qualityscore_doc_4}</p>
			<ul>
				<li>${this._t?.pnx.qualityscore_doc_41}</li>
				<li>${this._t?.pnx.qualityscore_doc_42}</li>
			</ul>
			<p>${this._t?.pnx.qualityscore_doc_5}</p>
			<pnx-link-button
				href="https://docs.panoramax.fr/pictures-metadata/quality_score/"
				target="_blank"
				kind="outline"
				style="width: 100%"
			>${fa(faExternalLinkAlt)} ${this._t?.pnx.popup_details_link}</pnx-link-button>
		`;
	}
}

customElements.define("pnx-quality-score-doc", QualityScoreDoc);
